// Module
var code = "<h2 class=\"heading--isInteriorPageSubHeading\"> Mobile App Features </h2> ";
// Exports
export default code;